export var defaultOrdinal = '%d';
export var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

export function ordinal (number) {
    return this._ordinal.replace('%d', number);
}




//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/ordinal.js
// module id = 402
// module chunks = 113